import { graphql } from '../../graphql/generated';

export const REQUEST_TRUNCATED_QUERY = graphql(`
  query RequestTruncated($requestId: ID!) {
    request(id: $requestId) {
      id
      ordersTruncated
    }
  }
`);

export const REQUEST_SUMMARY_QUERY = graphql(`
  query RequestSummary($catalogParamIds: [ID!]!, $requestIdForReorder: ID, $doctorId: ID!) {
    insurances {
      id
      code
      shortName
    }

    requiredForms(catalogParamIds: $catalogParamIds, requestIdForReorder: $requestIdForReorder, doctorId: $doctorId) {
      id
      name
      header
      description
      fields {
        id
        name
        type
        required
        placeholder
        label
        help
        defaultValue
        regex
        options {
          label
          selected
          value
        }
      }
    }

    labs {
      id
      name
      diagnoseRequired
      elgaOptOut
      elgaOptOutText
    }

    doctor(id: $doctorId) {
      id
      showPriceSuggestion
      showPrices
      patientBilling
      flipParamNames
      addEmptyLabels
      addZplLabels
      zplLabelTemplate
    }
  }
`);

export const CREATE_REQUEST_MUTATION = graphql(`
  mutation CreateRequest($input: CreateRequestInput!) {
    createRequest(input: $input) {
      ...RequestSummary_SavedRequest
    }
  }
`);

export const UPDATE_REQUEST_MUTATION = graphql(`
  mutation UpdateRequest($input: UpdateRequestInput!) {
    updateRequest(input: $input) {
      ...RequestSummary_SavedRequest
    }
  }
`);

export const REORDER_MUTATION = graphql(`
  mutation Reorder($input: ReorderInput!) {
    reorder(input: $input) {
      request {
        ...RequestSummary_SavedRequest
      }
      newOrdersCorrelationId
    }
  }
`);

export const SavedRequestFragment = graphql(`
  fragment RequestSummary_SavedRequest on Request {
    id
    status
    orders {
      id
      aisExportedAt
      correlationId
      orderFiles {
        id
        fileName
        printedAt
        printable
        printRequired
        printBeforeSend
        printCopies
      }
      orderLabels {
        id
        printedAt
        specimenId
        testTubeId
        location
        specialPrinterRequired
      }
    }
    additionalData
  }
`);
